import { setCookie as setControlledCookie } from '@atlassian/browser-storage-controls';
import { SUCCESS_STATUS } from '../../constants.tsx';
import type { CookieAttributes } from '../../types.tsx';

export const setCookie = async (
	key: string,
	value: string,
	attributes?: CookieAttributes,
): Promise<boolean> => {
	const result = await setControlledCookie(key, value, attributes);
	return result === SUCCESS_STATUS;
};
